module.exports = __webpack_public_path__ + "static/media/nginx.3868dbe5.svg";